import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { ProductPreviewModal } from "./productPreviewModal.js";

// This will need to be moved outside of the component
import { productPreviewUrlsService } from "../../services/index.js";
import styled from "styled-components";

const PreviewLink = styled.div`
  color: #3e7697;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
  @media (max-width: 768px) {
    margin-top: 2%;
  }
`;

const ProductPreview = ({ row }) => {
  const [previewurls, setPreviewUrls] = useState([]);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (previewurls.length > 0) {
      setShowModal(true);
    }
  }, [previewurls]);

  // this will change when service is moved outside of component
  const handleClickedPreview = () => {
    if (row && row.productId) {
      productPreviewUrlsService(row).then((resp) => {
        const { data } = resp;
        setPreviewUrls(data.response);
      });
    }
  };

  return (
    <>
      <PreviewLink onClick={handleClickedPreview}>Preview</PreviewLink>
      <ProductPreviewModal
        show={showModal}
        onHide={() => setShowModal(false)}
        previewurls={previewurls}
      />
    </>
  );
};

// service should be used as prop
ProductPreview.propTypes = {
  row: PropTypes.shape({
    brand: PropTypes.string,
    productId: PropTypes.number,
    productName: PropTypes.string,
    siteId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status: PropTypes.string,
    website: PropTypes.string,
  }),
};

export default ProductPreview;
